
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useEmailTemplates = () => {
  /**
   * Send password reset email
   */
  const sendPasswordResetEmail = async (email: string) => {
    if (!email || email.trim() === "") {
      console.error("Invalid email provided to sendPasswordResetEmail");
      return { success: false, error: new Error("Email is required") };
    }

    try {
      console.log(`Sending password reset email to: ${email}`);
      
      const { error } = await supabase.auth.resetPasswordForEmail(email.trim(), {
        redirectTo: `${window.location.origin}/reset-password`
      });

      if (error) {
        console.error('Password reset error:', error);
        toast.error('Failed to send password reset email');
        throw error;
      }

      toast.success('Password reset email sent');
      return { success: true };
    } catch (error) {
      console.error('Error sending password reset:', error);
      toast.error('An error occurred while sending the password reset email');
      return { success: false, error };
    }
  };

  /**
   * Send welcome email with credentials to a new user
   */
  const sendCredentialsEmail = async (
    email: string,
    password: string,
    firstName: string,
    forcePasswordChange: boolean
  ) => {
    try {
      const { error } = await supabase.functions.invoke('send-credentials', {
        body: {
          email,
          password,
          firstName,
          forcePasswordChange
        }
      });

      if (error) {
        console.error('Error sending credentials email:', error);
        throw new Error(error.message || 'Failed to send credentials email');
      }

      return { success: true };
    } catch (error) {
      console.error('Error in sendCredentialsEmail:', error);
      // Don't show error toast here, let the calling component decide
      return { success: false, error };
    }
  };

  /**
   * Send custom password reset email template
   */
  const sendCustomPasswordResetEmail = async (email: string, resetLink: string, firstName?: string) => {
    try {
      const { error } = await supabase.functions.invoke('send-credentials', {
        body: {
          type: 'reset-password',
          email,
          resetLink,
          firstName
        }
      });

      if (error) {
        console.error('Error sending password reset email:', error);
        throw new Error(error.message || 'Failed to send password reset email');
      }

      return { success: true };
    } catch (error) {
      console.error('Error in sendCustomPasswordResetEmail:', error);
      return { success: false, error };
    }
  };

  return {
    sendCredentialsEmail,
    sendPasswordResetEmail,
    sendCustomPasswordResetEmail
  };
};
